module.exports = __webpack_public_path__ + "img/nl.d4811c27.svg";